import bounceApiClient from 'legacy/common/utils/bounceApiClient';

import {
  IncomingAssociationFormCreationDto,
  IncomingAssociationFormUpdateDto,
  OutgoingAssociationFormDto,
  OutgoingAssociationFormsDto,
  IncomingFormResponseDto,
  OutgoingFormResponseDto,
  OutgoingUploadedFileDto,
  GenericSuccessDto
} from 'api/dtos/workflows/forms';

export async function createAssociationForm({
  associationId,
  form
}: {
  associationId: string;
  form: IncomingAssociationFormCreationDto;
}): Promise<OutgoingAssociationFormDto> {
  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/forms`,
    form
  );

  return data;
}

export async function getAssociationForms(
  associationId: string
): Promise<OutgoingAssociationFormsDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/forms`
  );

  return data;
}

export async function getAssociationFormById({
  associationId,
  formId
}: {
  associationId: string;
  formId: string;
}): Promise<OutgoingAssociationFormDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/forms/${formId}`
  );

  return data;
}

export async function updateAssociationForm({
  associationId,
  formId,
  form
}: {
  associationId: string;
  formId: string;
  form: IncomingAssociationFormUpdateDto;
}): Promise<OutgoingAssociationFormDto> {
  const { data } = await bounceApiClient.put(
    `/api/associations/${associationId}/forms/${formId}`,
    form
  );

  return data;
}

export async function createFormResponse({
  associationId,
  formId,
  response
}: {
  associationId: string;
  formId: string;
  response: IncomingFormResponseDto;
}): Promise<OutgoingFormResponseDto> {
  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/forms/${formId}/responses`,
    response
  );

  return data;
}

export async function getFormResponse({
  associationId,
  formId,
  responseId
}: {
  associationId: string;
  formId: string;
  responseId: string;
}): Promise<OutgoingFormResponseDto> {
  const { data } = await bounceApiClient.get(
    `/api/associations/${associationId}/forms/${formId}/responses/${responseId}`
  );

  return data;
}

export async function updateFormResponse({
  associationId,
  formId,
  responseId,
  response
}: {
  associationId: string;
  formId: string;
  responseId: string;
  response: IncomingFormResponseDto;
}): Promise<OutgoingFormResponseDto> {
  const { data } = await bounceApiClient.put(
    `/api/associations/${associationId}/forms/${formId}/responses/${responseId}`,
    response
  );

  return data;
}

export async function uploadFiles({
  associationId,
  file
}: {
  associationId: string;
  file: File;
}): Promise<OutgoingUploadedFileDto> {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await bounceApiClient.post(
    `/api/associations/${associationId}/forms/files`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return data;
}

export async function deleteFile({
  associationId,
  filename
}: {
  associationId: string;
  filename: string;
}): Promise<GenericSuccessDto> {
  const { data } = await bounceApiClient.delete(
    `/api/associations/${associationId}/forms/files/${filename}`
  );

  return data;
}
